import React from 'react';
import Cookie from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Form, Checkbox, Button } from 'antd';

import TimeZoneSelect from '@src/components/TimeZoneSelect';
import { BigInput, BigPWDInput } from '@src/components/form';
import { cryptoEncrypt, cryptoDecrypt } from '@src/utils/encryption';
// import { login } from '@src/services/login';
import { loginIn, setXsrfToken } from '@src/services/loginUser';
import { UserInfoStore } from '@src/store/UserInfoData/Provider';
import ImgCom from '@src/components/ImgCom';

import styles from './styles.module.less';

const LoginForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = React.useRef(null);

  const { state, dispatch } = React.useContext(UserInfoStore);
  const [subLoading, setSubLoading] = React.useState(false);
  const [timeZoneData, setTimeZoneData] = React.useState({
    time: '',
    locale: ''
  });

  React.useEffect(() => {
    if (localStorage.getItem('operatorU') && localStorage.getItem('operatorP')) {
      formRef.current.setFieldValue('email', cryptoDecrypt(localStorage.getItem('operatorU') || ''));
      formRef.current.setFieldValue('password', cryptoDecrypt(localStorage.getItem('operatorP') || ''));
      formRef.current.setFieldValue('remember', true);
    }
  }, []);

  const onFinish = async (data) => {
    setSubLoading(true);

    const res = await loginIn({
      ...data,
      ...timeZoneData,
    });

    setSubLoading(false);

    if (res) {
      Cookie.set('fromTo', 'operatorWeb')
      Cookie.set('userLoginLocale', timeZoneData.locale);
      Cookie.set('uID', cryptoEncrypt(res?.user?.id));
      localStorage.setItem('permissions', res?.user?.permissions);

      // 记住密码
      if (!!data.remember) {
        localStorage.setItem('operatorU', cryptoEncrypt(data.email));
        localStorage.setItem('operatorP', cryptoEncrypt(data.password));
      } else {
        localStorage.removeItem('operatorU');
        localStorage.removeItem('operatorP');
      }
      navigate('/');
      window.location.reload();
    }
  };

  return (
    <div className={styles.login_form}>
      <div className={styles.img_box}>
        <ImgCom
          src={state.companyLogo}
          alt=""
          style={{ maxWidth: 180 }}
        />
      </div>
      <div className={styles.form_box}>
        <Form
          layout='vertical'
          ref={formRef}
          onFinish={onFinish}
        >
          <Form.Item
            style={{ display: 'none' }}
          >
            <TimeZoneSelect
              name="timeZone"
              setTimeZoneData={setTimeZoneData}
            />
          </Form.Item>
          <Form.Item
            name="email"
            label={t("Email")}
            rules={[
              {
                required: true,
                message: t("Please enter your Email")
              },
              {
                type: 'email',
                message: t('Please enter the correct E-mail format')
              }
            ]}
          >
            <BigInput name="email" placeholder={t("Please enter your Email")} />
          </Form.Item>
          <Form.Item
            name="password"
            label={t("Password")}
            rules={[
              {
                required: true,
                message: t("Please enter your Password")
              }
            ]}
          >
            <BigPWDInput name="password" placeholder={t("Please enter your Password")} />
          </Form.Item>
          <div className={styles.remember}>
            <Form.Item
              name="remember"
              valuePropName="checked"
            >

              <Checkbox name="remember">{t("Remember me")}</Checkbox>
            </Form.Item>
            <Button type="link" onClick={() => navigate('/login/forgotPWD')}>{t("Forgot Password")}?</Button>
          </div>
          <Button
            type="primary"
            htmlType="submit"
            className={styles.submit_btn}
            loading={subLoading}
          >
            {t("Login")}
          </Button>
        </Form>
      </div>
    </div>
  )
};

export default LoginForm;